import { FormEvent, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';

const contacts = [
  { icon: 'ri-whatsapp-line', label: 'WhatsApp', value: '(49) 9 9195-0002', href: 'https://wa.me/554991950002', note: 'Resposta rápida pelo WhatsApp' },
  { icon: 'ri-mail-line', label: 'E-mail', value: 'mauricio@grupobni.com.br', href: 'mailto:mauricio@grupobni.com.br', note: 'Envie documentos e propostas' },
  { icon: 'ri-map-pin-2-line', label: 'Endereço', value: 'Rua Mondaí, 97', href: 'https://www.google.com/maps/search/?api=1&query=Rua+Mondai+97+Engenho+Braun+Chapeco+SC', note: 'Bairro Engenho Braun — Chapecó/SC' },
];

export default function Contato() {
  const [sent, setSent] = useState(false);

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const message = [
      'Olá! Entrei em contato pelo site da BNI.',
      '',
      `Nome: ${form.get('nome')}`,
      `Telefone: ${form.get('telefone')}`,
      `E-mail: ${form.get('email')}`,
      `Assunto: ${form.get('assunto')}`,
      `Mensagem: ${form.get('mensagem')}`,
    ].join('\n');

    setSent(true);
    window.open(`https://wa.me/554991950002?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <section className="relative overflow-hidden bg-[#061a35] px-6 py-20 text-white md:px-8 md:py-24">
        <div className="absolute -right-28 -top-36 h-96 w-96 rounded-full border-[70px] border-primary-500/10" />
        <div className="absolute -bottom-52 right-40 h-80 w-80 rounded-full bg-primary-500/10 blur-3xl" />
        <div className="relative">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[.18em]"><i className="ri-chat-3-line text-primary-400" /> Fale com a BNI</span>
          <h1 className="max-w-3xl text-4xl font-extrabold leading-tight md:text-6xl">Vamos conversar sobre seu <span className="text-primary-400">próximo imóvel?</span></h1>
          <p className="mt-6 max-w-2xl text-base leading-8 text-white/70 md:text-lg">Nossa equipe está pronta para entender o que você precisa e tornar sua negociação mais simples, segura e transparente.</p>
        </div>
      </section>

      <section className="relative z-10 -mt-8 px-6 md:px-8">
        <div className="grid gap-5 md:grid-cols-3">
          {contacts.map((contact) => (
            <a key={contact.label} href={contact.href} target={contact.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer" className="group rounded-2xl border border-slate-200 bg-white p-6 shadow-lg hover:-translate-y-1 hover:shadow-xl">
              <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-2xl text-primary-500 group-hover:bg-primary-500 group-hover:text-white"><i className={contact.icon} /></span>
              <span className="mb-1 block text-xs font-extrabold uppercase tracking-wider text-slate-400">{contact.label}</span>
              <strong className="block break-words text-base text-secondary-950">{contact.value}</strong>
              <span className="mt-2 block text-xs leading-5 text-slate-500">{contact.note}</span>
            </a>
          ))}
        </div>
      </section>

      <section className="px-6 py-20 md:px-8 md:py-24">
        <div className="grid gap-14 lg:grid-cols-[.75fr_1.25fr]">
          <div>
            <span className="mb-3 block text-xs font-extrabold uppercase tracking-[.2em] text-primary-500">Atendimento personalizado</span>
            <h2 className="mb-5 text-3xl font-extrabold leading-tight text-secondary-950 md:text-4xl">Conte o que você procura.</h2>
            <p className="mb-8 text-base leading-8 text-slate-600">Preencha o formulário e sua mensagem será preparada para envio direto ao nosso WhatsApp. Assim conseguimos atender você com mais contexto e agilidade.</p>

            <div className="space-y-5 rounded-2xl bg-slate-50 p-7">
              <div className="flex gap-4"><i className="ri-time-line mt-1 text-xl text-primary-500" /><div><strong className="block text-sm text-secondary-950">Horário de atendimento</strong><span className="text-sm leading-6 text-slate-500">Segunda a sexta, das 8h às 18h<br />Sábado, das 8h às 12h</span></div></div>
              <div className="h-px bg-slate-200" />
              <div className="flex gap-4"><i className="ri-shield-check-line mt-1 text-xl text-primary-500" /><div><strong className="block text-sm text-secondary-950">Seus dados estão seguros</strong><span className="text-sm leading-6 text-slate-500">As informações são usadas somente para responder ao seu atendimento.</span></div></div>
            </div>
          </div>

          <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-xl md:p-9">
            <div className="grid gap-5 md:grid-cols-2">
              <label className="contact-field"><span>Nome completo *</span><input name="nome" type="text" required placeholder="Como podemos chamar você?" /></label>
              <label className="contact-field"><span>Telefone / WhatsApp *</span><input name="telefone" type="tel" required placeholder="(49) 9 9999-9999" /></label>
              <label className="contact-field"><span>E-mail *</span><input name="email" type="email" required placeholder="seuemail@exemplo.com" /></label>
              <label className="contact-field"><span>Assunto *</span><select name="assunto" required defaultValue=""><option value="" disabled>Selecione uma opção</option><option>Comprar um imóvel</option><option>Vender meu imóvel</option><option>Alugar um imóvel</option><option>Anunciar para locação</option><option>Avaliação de imóvel</option><option>Outro assunto</option></select></label>
              <label className="contact-field md:col-span-2"><span>Mensagem *</span><textarea name="mensagem" required rows={5} placeholder="Conte um pouco sobre o que você precisa..." /></label>
            </div>
            <label className="mt-5 flex cursor-pointer items-start gap-3 text-xs leading-5 text-slate-500"><input type="checkbox" required className="mt-1 accent-primary-500" /><span>Autorizo a BNI a utilizar os dados informados para entrar em contato sobre este atendimento.</span></label>
            <button type="submit" className="mt-7 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-4 text-sm font-extrabold text-white hover:bg-primary-600"><i className="ri-whatsapp-line text-xl" /> ENVIAR PELO WHATSAPP</button>
            {sent && <p className="mt-4 text-center text-sm font-semibold text-green-600" role="status">Mensagem preparada. Continue o envio no WhatsApp.</p>}
          </form>
        </div>
      </section>

      <Footer />
    </main>
  );
}
